//@ts-nocheck
import { commonBase } from '@kid/meta-color/color/output/common';
import React from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View, } from 'react-native';
import { rem } from '../../utils/rem';
import Icon from '../Icon';
import { PopupV2 as Popup } from '../PopupV2';
const ScaleContext = React.createContext({ rem });
export const DialogComponent = function (props) {
    const { rem } = React.useContext(ScaleContext);
    const { visible = false, componentApi = true, wrapStyle = {}, width = rem(318), onConfirm = () => { }, onCancel = () => { }, showLeftButton = true, cancelText = null, confirmText = '', showButton = true, showDesc = true, showTitle = true, title = null, content = null, titleStyle = {}, descTextStyle = {}, renderButton = null, renderContent = null, renderTop = null, renderCloseIcon = null, onPressCloseIcon = () => { }, closeIconStyle = {}, popupSet = {}, closeIcon = true, borderRadius = rem(12), leftButtonColor = '#666666', rightButtonColor = '#fff', borderColor = '#eaeaea', titleColor = '#222222', descTextColor = '#666666', wrapBackGroundColor = '#fff', 
    // popup中的属性
    useModal, showMask, maskBgColor, maskClosable, position, top, left, animate, animateDuration, isControlAnimationIn, popupStyle, maskStyle, beforeClose, onAnimateEnd, onShow, onDismiss, } = props;
    const popupProps = {
        useModal,
        showMask,
        maskBgColor,
        maskClosable,
        position,
        top,
        left,
        animate,
        animateDuration,
        isControlAnimationIn,
        popupStyle,
        maskStyle,
        beforeClose,
        onAnimateEnd,
        onShow,
        onDismiss,
    };
    const styles = StyleSheet.create({
        title: {
            fontSize: rem(18),
            lineHeight: rem(22),
            maxHeight: rem(92),
            marginTop: rem(8),
            textAlign: 'center',
            fontFamily: 'PingFangSC-Regular',
        },
        desc: {
            fontSize: rem(15),
            lineHeight: rem(18),
            marginTop: rem(16),
            justifyContent: 'center',
            fontFamily: 'PingFangSC-Regular',
            textAlign: 'center',
        },
        buttonWrap: {
            flexDirection: 'row',
            height: rem(48),
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: rem(32),
        },
        leftButton: {
            flex: 0.5,
            justifyContent: 'center',
            paddingTop: rem(10),
            paddingBottom: rem(10),
            paddingLeft: rem(24),
            paddingRight: rem(24),
            borderRadius: rem(6),
            borderWidth: rem(1),
            marginRight: rem(12),
        },
        rightButton: {
            flex: 0.5,
            justifyContent: 'center',
            paddingTop: rem(10),
            paddingBottom: rem(10),
            paddingLeft: rem(24),
            paddingRight: rem(24),
            borderRadius: rem(6),
        },
        leftText: {
            textAlign: 'center',
            fontFamily: 'PingFangSC-Regular',
            fontSize: rem(16),
            lineHeight: rem(21),
        },
        closeIcon: {
            position: 'absolute',
            zIndex: 99,
            top: rem(14.74),
            right: rem(14.74),
        },
    });
    const renderCloseIconComponent = () => {
        return (React.createElement(View, { style: [styles.closeIcon] },
            React.createElement(Icon, { onPress: () => {
                    onCancel();
                }, name: "kibt_ecommerce_c_close", customStyle: {
                    iconSize: 26,
                } })));
    };
    const renderButtonComponent = () => {
        if (cancelText === null && confirmText === null)
            return null;
        return (React.createElement(View, { style: [styles.buttonWrap, { borderColor: borderColor }] },
            showLeftButton && cancelText !== null && (React.createElement(TouchableOpacity, { onPress: () => {
                    onCancel();
                }, hitSlop: {
                    top: rem(20),
                    left: rem(20),
                    bottom: rem(20),
                }, style: [
                    {
                        borderColor: commonBase.kiui_color_base_black_1_a12,
                        backgroundColor: commonBase.kiui_color_base_white_1,
                    },
                    styles.leftButton,
                ] },
                React.createElement(Text, { style: [
                        {
                            color: leftButtonColor ||
                                commonBase.kiui_color_base_black_1_a88,
                        },
                        styles.leftText,
                    ] }, cancelText))),
            confirmText !== null ? (React.createElement(TouchableOpacity, { style: [
                    {
                        flex: 0.5,
                        backgroundColor: commonBase.kiui_color_base_red_1,
                    },
                    styles.rightButton,
                ], hitSlop: {
                    top: rem(20),
                    right: rem(20),
                    bottom: rem(20),
                }, onPress: () => {
                    onConfirm();
                } },
                React.createElement(Text, { style: [
                        {
                            textAlign: 'center',
                            color: rightButtonColor ||
                                commonBase.kiui_color_base_black_1_a88,
                            fontFamily: 'PingFangSC-Regular',
                            fontSize: rem(16),
                            lineHeight: rem(21),
                        },
                    ] }, confirmText))) : null));
    };
    const renderTitle = () => {
        return typeof title === 'string' ? (React.createElement(Text, { style: [
                { color: titleColor },
                styles.title,
                Platform.OS === 'android' && { fontWeight: '500' },
                titleStyle,
            ] }, title)) : (title);
    };
    const renderDesc = () => {
        if (content === '') {
            return null;
        }
        return typeof content === 'string' ? (React.createElement(Text, { style: [
                {
                    color: descTextColor,
                    marginTop: showTitle ? rem(12) : 0,
                },
                styles.desc,
                descTextStyle,
            ] }, content)) : (content);
    };
    const renderContentComponent = () => {
        var _a;
        const closeIconNode = renderCloseIcon === null || renderCloseIcon === void 0 ? void 0 : renderCloseIcon();
        const topNode = renderTop === null || renderTop === void 0 ? void 0 : renderTop();
        const contentNode = renderContent === null || renderContent === void 0 ? void 0 : renderContent();
        const buttonNode = renderButton === null || renderButton === void 0 ? void 0 : renderButton();
        return (React.createElement(View, { style: [
                {
                    backgroundColor: wrapBackGroundColor,
                    width: width,
                    borderRadius: borderRadius,
                    paddingHorizontal: rem(24),
                    paddingTop: (_a = popupStyle === null || popupStyle === void 0 ? void 0 : popupStyle.paddingTop) !== null && _a !== void 0 ? _a : rem(24),
                    paddingBottom: renderContent || (popupStyle === null || popupStyle === void 0 ? void 0 : popupStyle.paddingTop)
                        ? (popupStyle === null || popupStyle === void 0 ? void 0 : popupStyle.paddingTop) || rem(12)
                        : rem(24),
                },
                wrapStyle,
            ] },
            closeIconNode ? (React.createElement(TouchableOpacity, { onPress: () => {
                    onPressCloseIcon();
                }, style: [styles.closeIcon, closeIconStyle], hitSlop: {
                    left: rem(20),
                    right: rem(20),
                    top: rem(20),
                    bottom: rem(20),
                } }, closeIconNode)) : null,
            !closeIconNode && closeIcon && renderCloseIconComponent(),
            topNode ? (React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, topNode)) : null,
            (showTitle || showDesc) && (React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                showTitle && renderTitle(),
                showDesc && renderDesc())),
            contentNode ? (React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, contentNode)) : null,
            buttonNode ? (React.createElement(View, { style: {
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingBottom: rem(32),
                } }, buttonNode)) : null,
            showButton && !renderButton && renderButtonComponent()));
    };
    return (React.createElement(React.Fragment, null, componentApi ? (React.createElement(Popup, Object.assign({}, popupSet, popupProps, { visible: visible }), renderContentComponent())) : (renderContentComponent())));
};
